import { useQuery } from '@tanstack/react-query'
import { getServiceAreaOverrideRule } from '../../../api/plan-service-area-override-rules-api'

export const SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY = 'serviceAreaOverrideRule'

export function useGetServiceAreaOverrideRule(id?: string) {
  return useQuery({
    queryKey: [SERVICE_AREA_OVERRIDE_RULE_QUERY_KEY, id],
    queryFn: async () => {
      if (!id) {
        throw new Error('Service area override rule id is required')
      }
      return getServiceAreaOverrideRule(id)
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  })
}
